import { Config } from './config';

export default function computeUrl(){
    return `https://${Config.host}${window.location.pathname}`;
}